import {
    Holiday,
    HolidayState,
    HolidayType,
    Operator,
    useGetHolidaysMutation,
    useGetHolidayTypesMutation,
    useGetUsersMutation
} from '@services';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useMesCongesPageVM = () => {
    const [holidays, setHolidays] = useState<Holiday[]>([]);
    const [operators, setOperators] = useState<Operator[]>([]);
    const [holidayTypes, setHolidayTypes] = useState<HolidayType[]>([]);

    const [getUsers, { isLoading: isLoadingUsers, error: errorUsers, data: users }] = useGetUsersMutation();
    const [getHolidays, { isLoading, error, data }] = useGetHolidaysMutation();
    const [getHolidayTypes, { isLoading: isLoadingHolidayTypes, error: errorHolidayTypes, data: dataHolidayTypes }] =
        useGetHolidayTypesMutation();
    const navigate = useNavigate();

    useEffect(() => {
        getHolidays(undefined);
        getUsers(undefined);
        getHolidayTypes(undefined);
    }, [getHolidays, getUsers, getHolidayTypes]);

    useEffect(() => {
        if (error) {
            console.error(error);
        }
        if (data) {
            setHolidays(data);
        }
    }, [isLoading, data, error]);

    useEffect(() => {
        if (errorUsers) {
            console.error(errorUsers);
        }
        if (users) {
            setOperators(users.operators);
        }
    }, [users, isLoadingUsers, errorUsers]);

    useEffect(() => {
        if (errorHolidayTypes) {
            console.error(errorHolidayTypes);
        }
        if (dataHolidayTypes) {
            setHolidayTypes(dataHolidayTypes);
        }
    }, [errorHolidayTypes, dataHolidayTypes, isLoadingHolidayTypes]);

    return {
        holidays,
        currentHolidays: useMemo(
            () => holidays.filter((holiday) => holiday.state_id === HolidayState.PENDING).sort((a, b) => Number(b.id) - Number(a.id)),
            [holidays]
        ),
        pastHolidays: useMemo(
            () => holidays.filter((holiday) => holiday.state_id !== HolidayState.PENDING).sort((a, b) => Number(b.id) - Number(a.id)),
            [holidays]
        ),
        isLoading: isLoading || isLoadingUsers,
        error: error || errorUsers,
        operators,
        holidayTypes,
        navigate
    };
};
